import { render, staticRenderFns } from "./Tracker.vue?vue&type=template&id=12fc122a&scoped=true&"
import script from "./Tracker.vue?vue&type=script&lang=js&"
export * from "./Tracker.vue?vue&type=script&lang=js&"
import style0 from "./Tracker.vue?vue&type=style&index=0&id=12fc122a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fc122a",
  null
  
)

export default component.exports